const NEGATION_REGEX =
  /\b(no|not|without|negative\s+for|no\s+evidence\s+of|no\s+signs?\s+of|no\s+history\s+of|free\s+of|denies|denied)\b/i;

function isNegated(text: string, matchIndex: number): boolean {
  const clauseStart = Math.max(
    text.lastIndexOf(".", matchIndex - 1) + 1,
    text.lastIndexOf(";", matchIndex - 1) + 1,
    text.lastIndexOf(",", matchIndex - 1) + 1,
    text.lastIndexOf("\n", matchIndex - 1) + 1,
    text.lastIndexOf("\r", matchIndex - 1) + 1,
    0
  );

  return NEGATION_REGEX.test(text.slice(clauseStart, matchIndex));
}

export function buildKeywordRegex(keywords: string[]): RegExp {
  const escaped = keywords.map((keyword) => keyword.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));

  return new RegExp(`\\b(?:${escaped.join("|")})\\b`, "gi");
}

export function textMatchesUnnegated(text: string | null | undefined, keywordRegex: RegExp): boolean {
  if (!text) return false;

  const globalRegex = keywordRegex.global ? keywordRegex : new RegExp(keywordRegex.source, `${keywordRegex.flags}g`);

  for (const match of text.matchAll(globalRegex)) {
    if (match.index === undefined) continue;
    if (!isNegated(text, match.index)) return true;
  }

  return false;
}
